import type { ApiClient } from "../../api/client";
import { setAllergenDictionary, type AllergenRule } from "../menu-admin/allergens";

/**
 * Tafo-beheer › Allergenenlijst: the list Tafo uses for the proposals, the same on every till and app.
 * Loaded at the start and again when Tafo changes it ("allergens.updated"). When it cannot be loaded,
 * the list that was there stays (at first: Tafo's standard list).
 */
export function loadAllergenDictionary(api: ApiClient): void {
  api
    .request<{ rules: AllergenRule[] | null }>("GET", "/device/allergens", { retry: true })
    .then((answer) => {
      setAllergenDictionary(answer.rules);
    })
    .catch(() => undefined);
}
